import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { FileSearchResultFragmentDoc } from '../../fragments/generated/fileSearchResult';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProjectStagesQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
}>;


export type ProjectStagesQuery = { file?: { id: string, name: string, category: Types.FileCategoryEnum, projectStatus?: Types.FileProjectStatusEnum | null, systemGenerated?: boolean | null, childrenIds?: Array<string> | null, stages?: Array<{ stageId: string, name: string, description?: string | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null } | null> | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null } | null };


export const ProjectStagesDocument = /*#__PURE__*/ gql`
    query projectStages($filters: GetByIdFilter!) {
  file(filters: $filters) {
    ...FileSearchResult
    stages {
      stageId
      name
      iconSettings {
        type
        value
      }
      description
    }
  }
}
    ${FileSearchResultFragmentDoc}`;

export function useProjectStagesQuery(options: Omit<Urql.UseQueryArgs<ProjectStagesQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectStagesQuery, ProjectStagesQueryVariables>({ query: ProjectStagesDocument, ...options });
};